const normalizeChatId = (value) => {
  if (value === undefined || value === null) {
    return null;
  }
  const normalized = String(value).trim();
  return normalized || null;
};

let pendingChatNavigationIntent = null;

export const stageChatNavigationIntent = (chatId) => {
  pendingChatNavigationIntent = normalizeChatId(chatId);
  return pendingChatNavigationIntent;
};

export const consumeChatNavigationIntent = () => {
  const intent = pendingChatNavigationIntent;
  pendingChatNavigationIntent = null;
  return intent;
};

